import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={(props.width || 184)}
    height={(props.width|| 181)}
    viewBox="0 0 184 181"
    fill="none"
    {...props}
  >
    <path
      stroke="url(#auj)"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M1.006 179.312 182.313 1.35"
    />
    <defs>
      <linearGradient
        id="auj"
        x1={1.003}
        x2={185.705}
        y1={179.672}
        y2={-2.634}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BEA56C" stopOpacity={0} />
        <stop offset={1} stopColor="#BEA56C" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgComponent
